import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'
const DigitalCommerce = () => {
    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                <div className="row">
                    <img
                        src="/theme/img/digital_services_0_0.jpg"
                        alt="Digital Services"
                        style={{ height: '300px', width: '100%' }}
                    />
                </div>
                <br />
                <div className="row">
                    <h2 className="elementor-heading-title elementor-size-default">
                        Digital solutions to help your business evolve and grow
                    </h2>
                    <p>
                        Tejaxo Woven is the digital consultancy division of Tejaxo Software. The team�s innovative solutions transform customer and employee engagement across digital channels � extending the capabilities of Tejaxo Xi ERP and driving strategic change. Tejaxo Woven helps organisations harness the power of real-time interactions from a single source of truth � to simplify operations and enhance customer experience. Working in synergy with Tejaxo Software, these ERP savvy creatives are redefining the boundaries of traditional business systems.
                    </p>
                </div>
                <br />
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img
                            src="/theme/img/digital-commerce-2-768x512.jpg"
                            alt="Digital Commerce"
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div className="col-lg-6 content">
                        <h2 className="elementor-heading-title elementor-size-default">
                            Online and ready to sell
                        </h2>
                        <p>
                            We understand that ecommerce isn�t one part of your business, it is your business. With this in mind, our team of experts have designed Tejaxo Xi Avenue to be fully integrated into existing business systems. It arms you with the tools to maximise efficiency and sales revenue.
                        </p>
                        <p>
                            Tejaxo Xi Mobile Sales app places the power in your sales team�s hands giving them anywhere, anytime access to the latest customer intelligence, real-time product and CRM data. Your team is also able to review orders and balances at a click, providing them with the information to foster the relationships that help grow your business.
                        </p>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default DigitalCommerce;
